import styled from 'styled-components';
import { Stack } from '@karma/components';

export const PropertiesSelectLists = styled(Stack)`
  flex-wrap: wrap;
`;
